<template>
  <div @click="doToggle"
      :class="calcClass"
      :title="calcTitle"
      class="toggle btn"
      style="width: 32px; height: 20px;"
  >
    <div class="toggle-group">
      <label class="btn btn-success toggle-on">On</label>
      <label class="btn btn-danger active toggle-off">Off</label>
      <span class="toggle-handle btn btn-default"></span>
    </div>
  </div>
</template>

<script>
// V1-styled on/off switch
export default {
  name: "SwitchLegacy",
  props: {
    value: Boolean,
    title: {
      type: String,
      default: '',
    }
  },
  methods: {
    doToggle() {
      this.$emit('click', !this.value);
    }
  },
  computed: {
    calcClass() {
      return {
        'on': this.value,
        'btn-success': this.value,
        'off': !this.value,
        'btn-danger': !this.value,
      }
    },
    calcTitle() {
      return (this.title ? this.title+": " : "") + (this.value ? "On" : "Off")
    },
  },
}
</script>

<style>

</style>